import sortedByDate from "./modeles/sorted-by-date";
import recentsModeles from "./modeles/recents-modeles";

const [, , , id] = location.hash.match(/(#)(R?)([0-9]*)/) || ["", "", ""];
const idHash = id !== "" && sortedByDate[parseInt(id, 10)] ? id : null;
const idRecent = recentsModeles()[0]?.id;
export default idHash || idRecent || 0;
